<template>
  <div id="app" class="smooth">
    <div v-if="$route.name && $route.name !== 'login' && $store.getters['authInfo'] && $store.getters['activeRole']" class="wrapper" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
      <Sidebar />
      <div class="content">
        <Navbar :sidebar-collapsed="sidebarCollapsed" @toggle-sidebar="toggleDesktopSidebar" />
        <div class="content-body p-4 scroll-bar smooth" onscroll="sc()">
          <router-view />

          <!-- <div class="sticky-anchor"></div> -->
        </div>
      </div>
    </div>
    <div v-else>
      <router-view />
    </div>
  </div>
</template>
<script>
import Sidebar from "@/components/sidebar";
import Navbar from "@/components/navbar";
import { installerDicteeGlobale } from "@/utils/dictee-globale";

export default {
  data() { return { sidebarCollapsed: false, sidebarCollapsedAvantDossier: null }; },
  // Dictée vocale (04/10/2026) : bouton commun enregistré avant les écrans, bouton flottant pour tous les champs texte.
  beforeCreate() { if (typeof installerDicteeGlobale === 'function') installerDicteeGlobale(); },
  methods: {
    toggleDesktopSidebar() { this.sidebarCollapsed = !this.sidebarCollapsed; },
    estDansDossierMedical(route) {
      return Boolean(route && route.name === 'patientInfo' && route.params && route.params.consultation === 'consulter');
    },
    adapterSidebarAuDossier(route, previousRoute) {
      const dansDossier = this.estDansDossierMedical(route);
      const venaitDuDossier = this.estDansDossierMedical(previousRoute);
      if (dansDossier && !venaitDuDossier) {
        this.sidebarCollapsedAvantDossier = this.sidebarCollapsed;
        this.sidebarCollapsed = true;
      } else if (!dansDossier && venaitDuDossier) {
        this.sidebarCollapsed = this.sidebarCollapsedAvantDossier === null ? false : this.sidebarCollapsedAvantDossier;
        this.sidebarCollapsedAvantDossier = null;
      }
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(route, previousRoute) { this.adapterSidebarAuDossier(route, previousRoute); },
    },
  },
  components: {
    Sidebar,
    Navbar,
  },
};
</script>
<style lang="scss">
@media (min-width: 1201px) {
  .wrapper.sidebar-collapsed > #sdbr { transform: translateX(-100%); visibility: hidden; }
  .wrapper.sidebar-collapsed > .content { padding-left: 0; }
  .wrapper.sidebar-collapsed > .content .navbar { left: 0; }
}
@media (prefers-reduced-motion: reduce) { #sdbr.sidebar { transition: none; } }
.input-secondary-light {
  background: unset !important;
}
.spinner-grow {
  width: 1.5rem !important;
  height: 1.5rem !important;
}
.smooth {
  scroll-behavior: smooth;
}
</style>
